import React from "react";
import { TypographyTypes } from "@components/typography";
import { StyledCaption } from "./helperText.styles";
import { HelperTextProps } from "./helperText.types";

export const HelperText = ({ children, type, ...rest }: HelperTextProps) => {
    return (
        <StyledCaption
            type={type ?? TypographyTypes.secondary}
            level={3}
            {...rest}
        >
            {children}
        </StyledCaption>
    );
};

HelperText.displayName = "HelperText";
